import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../_services/auth.service';

export class FormInput {
  accountnumber: any;
  username: any;
  password: any;
}

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  formInput: FormInput;
  form: any;
  loading = false;
  public isSubmit: boolean;
  returnUrl: string;
  error = '';
  isLoginFailed = false;

  constructor(
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private authenticationService: AuthService
  ) {
    this.isSubmit = false;
    // redirect to home if already logged in and token is still valid
    if (this.authenticationService.currentUserValue) {
      if (new Date(this.authenticationService.currentUserValue.expiryDate) > new Date()) {
        this.router.navigate(['/']);
      }
      else {
        this.authenticationService.logout();
      }
    }
  }

  ngOnInit() {
    this.formInput = {
      accountnumber: '',
      username: '',
      password: '',
    }

    // get return url from route parameters or default to '/'
    this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';
  }

  save(form: any) {
    if (!form.valid) {
      this.isSubmit = true;
      return;
    }
    else {
      //var credentials;
      //credentials.accountnumber = form.form.controls.accountnumber;
      //credentials.username = form.form.controls.username;
      //credentials.password = form.form.controls.password;

      this.loading = true;
      this.authenticationService.login(form.value)
        .subscribe(
          data => {
            console.log("Login complete");
            this.router.navigate([this.returnUrl]);
          },
          error => {
            this.isLoginFailed = true;
            this.isSubmit = true;
            this.error = error;
            this.loading = false;
          });
    }
  }
}
